import {HIERARCHY_PICKER_CHANGE_STATE, useSuiteHierarchyId} from '@hproduce/suite-core'
import {useCallback} from 'react'
import {useLocation, useNavigate} from 'react-router'

/**
 * wrapper around suite core hierarchy id hook
 * - returns hierarchy id from url if exists
 * - provides setHierarchyId function to update hierarchy id in url without losing current path and search params
 * @returns[hierarchyId, setHierarchyId]
 */

export const useHierarchyIdFromURL = (): [
  hierarchyId: string | null,
  setHierarchyId: (id: string) => void
] => {
  const hierarchyId = useSuiteHierarchyId()
  const navigate = useNavigate()
  const location = useLocation()

  const setHierarchyId = useCallback(
    (id: string) => {
      // Replace hierarchyId segment in the current path
      // Pattern: /:featureName/hierarchyId/:hierarchyId/*
      const newPath = location.pathname.replace(/\/hierarchyId\/[^/]+/, `/hierarchyId/${id}`)
      // Marks the switch so features whose sub-path belongs to the previous node can reset it
      void navigate(newPath + location.search, {
        replace: true,
        state: HIERARCHY_PICKER_CHANGE_STATE
      })
    },
    [navigate, location]
  )

  return [hierarchyId ?? null, setHierarchyId]
}
